import React from 'react'

import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import ActionIcon from '@components/UI/ActionIcon'
import { ICampaignContextProps } from '@context/Campaign'
import { withCampaign } from '@hocs'
import { IApplicationState } from '@store'
import { selectIsShortlisting, shortlistSubmissionRequest } from '@store/submissions'
import Theme from '@theme'
import { getSubmissionFilter, getSubmissionSortBy } from '@utils'

interface IActionBarIconShortlistProps {
  submissionId: number
  refreshSubmissionsOnAction?: boolean
}

interface IInternalProps extends IActionBarIconShortlistProps, ICampaignContextProps {}

export const ActionBarIconShortlist: React.FC<IInternalProps> = ({
  submissionId,
  campaign,
  refreshSubmissionsOnAction = true,
}: IInternalProps) => {
  const intl = useIntl()
  const history = useHistory()
  const dispatch = useDispatch()

  const filter = getSubmissionFilter(history.location)
  const sortBy = getSubmissionSortBy(history.location)

  const isShortlisting = useSelector((state: IApplicationState) =>
    selectIsShortlisting(state, submissionId),
  )

  const onShortlistSubmission = () => {
    dispatch(
      shortlistSubmissionRequest(campaign.id, submissionId, {
        filter,
        sortBy,
        refreshSubmissions: refreshSubmissionsOnAction,
      }),
    )
  }

  return (
    <ActionIcon
      glyph="heart"
      color={Theme.grey900Color}
      size={1.5}
      onClick={onShortlistSubmission}
      tooltip={intl.formatMessage({ id: 'submission.card.action.addtoshortlist' })}
      elementName="shortlist"
      disabled={isShortlisting}
    />
  )
}

export default withCampaign(ActionBarIconShortlist)
